import script from "./NewApp.vue?vue&type=script&setup=true&lang=js"
export * from "./NewApp.vue?vue&type=script&setup=true&lang=js"

import "./NewApp.vue?vue&type=style&index=0&id=45584192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45584192"]])

export default __exports__